<template>
  <div class="set-fields">
    <a-alert
      type="info"
      class="clearfix"
    >
      <div
        slot="description"
      >
        <i class="iconfont iconicon-test34 fs-info fl" />
        为保证将星轨上的数据正确同步至小满，需要设置两个系统间的字段对应关系。
      </div>
    </a-alert>
    <div class="content">
      <!-- 字段对应： -->
      <div class="row clearfix">
        <label class="fl">字段对应：</label>
        <div class="item-wrap">
          <div class="top">
            <a
              v-if="!data.syncfieldtime"
              class="btn-text"
              :class="{ 'isclose': !data.isopen }"
              @click="handleGetFields"
            >
              获取小满字段
            </a>
            <template v-else>
              <p>
                <a
                  class="btn-text"
                  :class="{ 'isclose': !data.isopen }"
                  @click="handleGetFields"
                >重新获取小满字段</a>
                <span class="fs-gray666">（上次获取时间：{{ $moment(data.syncfieldtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}）</span>
              </p>
              <p class="fs-gray fs-12">
                如您在小满上的字段配置发生了变化，可重新获取
              </p>
            </template>
          </div>
        </div>
      </div>
      <a-spin
        :spinning="loading"
      >
        <fields-list
          ref="fieldsList"
          :data="data.xiaomanfieldassoc"
          :loading="fieldsLoading"
          :is-syncfield="isSyncfield"
        />
      </a-spin>
    </div>
    <!-- 保存按钮 -->
    <div
      v-if="data.xiaomanfieldassoc && data.xiaomanfieldassoc.length"
      class="footer-wrap"
    >
      <div
        v-if="data.xiaomanfieldassoc"
        ref="footer"
        class="footer"
      >
        <a-button
          type="primary"
          :disabled="isBtnDisable"
          @click="handleSubmit"
        >
          保存
        </a-button>
        <span
          v-if="count > 0"
          class="fs-gray"
        >保存本次更改？</span>
      </div>
    </div>

    <leave-tip-dialog
      ref="leaveTip"
      :confirm-text="leaveConfirmText"
      :cancel-text="leaveCancelText"
      @leavelHandler="leavelHandler"
    >
      <div
        slot="tip-slot"
      >
        字段对应设置尚未保存，<br>
        {{ leaveCancelText === '离开页面' ? '确定要离开当前页面？' : '确定要重新获取小满字段？' }}
      </div>
    </leave-tip-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import FieldsList from './FieldsList'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'
import { setFooterStyle } from '@/lib/utils'

export default {
  name: 'SetFieldMain',
  components: {
    FieldsList,
    LeaveTipDialog
  },

  data () {
    return {
      data: {
        isopen: 0,
        syncfieldtime: '',
        xiaomanfieldassoc: []
      },
      leaveConfirmText: '留在页面',
      leaveCancelText: '离开页面',
      leave: {},
      status: false,
      isSyncfield: false
    }
  },

  computed: {
    ...mapState('config/xiaoman', ['fieldsData', 'loading']),
    ...mapState('config/xiaoman/setFields', ['fieldsLoading', 'listDatas', 'count', 'isBtnDisable'])
  },

  watch: {
    fieldsData: {
      handler (val) {
        if (!val) return

        this.data = val
        setFooterStyle(this)
      },
      deep: true,
      immediate: true
    },
    count () {
      if (this.count > 0 && this.$route.name === 'XiaomanSetFields') {
        this.removeClick()
        this.addClick()
      }
    }
  },

  beforeRouteLeave (to, from, next) {
    this.removeClick()
    if (this.count > 0 && to.name !== 'XiaomanSetFields') {
      if (this.status) {
        this.SET_COUNT(0)
        next()
        return
      }
      this.leaveConfirmText = '留在页面'
      this.leaveCancelText = '离开页面'
      this.$refs.leaveTip.changeLimitDialog(true)
      this.leave = to
      next(false)
    } else {
      this.SET_COUNT(0)
      next()
    }
  },

  mounted () {
    this.fetchAllOptions() // 获取星轨字段所以的下拉选项
    window.addEventListener('resize', () => {
      setFooterStyle(this)
    })
    document.addEventListener('scroll', () => {
      setFooterStyle(this)
    })
  },

  methods: {
    ...mapActions(['addClick', 'removeClick']),
    ...mapActions('config/xiaoman/setFields', ['fetchXiaomanSyncFields', 'fetchAllOptions']),
    ...mapMutations('config/xiaoman', ['SET_LOADING']),
    ...mapMutations('config/xiaoman/setFields', ['SET_COUNT']),

    async handleGetFields () {
      if (!this.data.isopen) return

      if (this.count) {
        this.leaveConfirmText = '继续设置'
        this.leaveCancelText = '确认获取'
        this.$refs.leaveTip.changeLimitDialog(true)
        return
      }

      let chain = await this.fetchXiaomanSyncFields()
      chain
        .onSuccess((res = {}) => {
          let { xiaomanfieldassoc = [], syncfieldtime } = res

          this.data.xiaomanfieldassoc = []
          xiaomanfieldassoc.forEach(item => {
            this.data.xiaomanfieldassoc.push(item)
          })
          this.data.syncfieldtime = syncfieldtime
          this.isSyncfield = true
          this.$forceUpdate()
        })
    },

    async handleSubmit () {
      this.$refs.fieldsList && this.$refs.fieldsList.handleSubmit()
    },

    leavelHandler (isLeave) {
      const { leave } = this
      if (isLeave) { // 离开页面 或 重新获取字段
        this.status = true
        if (this.leaveCancelText === '确认获取') {
          this.SET_COUNT(0)
          this.handleGetFields()
        } else {
          this.$router.push({ name: leave.name, query: leave.query, params: leave.params })
        }
      } else { // 保持本页面
        this.status = false
      }
      this.$refs.leaveTip.changeLimitDialog(false)
    }
  }
}
</script>

<style scoped lang="scss">
.ant-alert {
  margin-bottom: 24px;
}
.ant-alert-message {
  display: none;
}
.ant-alert-with-description {
  padding: 8px 15px;
  line-height: 1;
  z-index: 99;
  .ant-alert-description {
    display: inline-block;
    .fs-info {
      margin-right: 12px;
    }
  }
}
.content {
  min-width: 1040px;
  .row > label {
    width: 106px;
    height: 24px;
    line-height: 24px;
    padding-right: 12px;
    text-align: right;
  }
  .item-wrap {
    padding-left: 108px;
    line-height: 24px;
  }
  .isclose {
    opacity: .5;
  }
}
.footer-wrap {
  height: 64px;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 64px;;
  z-index: 999;
  margin-left: -40px;
  padding: 16px 80px;
  background-color: #fff;
  border-top: solid 1px $gray4;
  transition: bottom 0.5s linear;
}
.ant-spin-spinning {
  display: block;
}
</style>
